import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { BaseApiService } from '../../base-service/base-api.service';

@Injectable()
export class WorkflowService extends BaseApiService {

    getWorkflowInstance(businessTransactionNumberId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/BusinessTransactionNumber/' + businessTransactionNumberId + '/WorkflowInstance');
    }

    getWorkflowForBusinessTransactionType(businessTransactionTypeId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/BusinessTransactionType/' + businessTransactionTypeId + '/Workflow');
    }

    startWorkflowForBusinessTransaction(businessTransactionNumberId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Workflow/Start/BusinessTransactionNumber/' + businessTransactionNumberId);
    }

    getWorkflowInstanceForBusinessTransaction(businessTransactionNumberId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/BusinessTransactionNumber/' + businessTransactionNumberId + '/WorkflowInstance');
    }

    getWorkflowInstanceStateForBusinessTransaction(businessTransactionNumberId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Workflow/Status/BusinessTransactionNumber/' + businessTransactionNumberId);
    }

    getReadyStepsForBusinessTransaction(businessTransactionNumberId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Workflow/Steps/Status/Ready/BusinessTransactionNumber/' + businessTransactionNumberId);
    }

    getReadySteps(workflowInstanceId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Workflow/Steps/Status/Ready/WorkflowInstance/' + workflowInstanceId);
    }

    getInProgressStepsForBusinessTransaction(businessTransactionNumberId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Steps/Status/InProgress/BusinessTransactionNumber/' + businessTransactionNumberId);
    }

    getInProgressSteps(workflowInstanceId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Workflow/Steps/Status/InProgress/WorkflowInstance/' + workflowInstanceId);
    }

    getCompletedStepsForBusinessTransaction(businessTransactionNumberId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Steps/Status/Completed/BusinessTransactionNumber/' + businessTransactionNumberId);
    }

    getCompletedSteps(workflowInstanceId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Workflow/Steps/Status/Completed/WorkflowInstance/' + workflowInstanceId);
    }

    startStep(workflowInstanceId: number, workflowStepId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Workflow/Steps/Start/WorkflowInstance/' + workflowInstanceId + '/WorkflowStep/' + workflowStepId);
    }

    completeStep(workflowInstanceId: number, workflowStepId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Workflow/Steps/Complete/WorkflowInstance/' + workflowInstanceId + '/WorkflowStep/' + workflowStepId);
    }

    failStep(workflowInstanceId: number, workflowStepId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Workflow/Steps/Fail/WorkflowInstance/' + workflowInstanceId + '/WorkflowStep/' + workflowStepId);
    }

    skipStep(workflowInstanceId: number, workflowStepId: number) {
        return this.get('Foundation/BusinessTransactionWorkflow/Workflow/Steps/Skip/WorkflowInstance/' + workflowInstanceId + '/WorkflowStep/' + workflowStepId);
    }

    private handleError(error: HttpErrorResponse) {
        return observableThrowError(error.error || 'Server error');
    }
}
